// New integrations API helpers
const LLM_URL = process.env.REACT_APP_LLM_URL || 'http://localhost:5001';

async function authHeaders() {
  // Get Keycloak auth token (getToken function now returns Keycloak JWT)
  try {
    const { getToken } = await import('../firebase.js');
    const token = await getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

export async function listIntegrations() {
  const res = await fetch(`/api/server/v1/integrations`, {
    headers: { 'Content-Type': 'application/json', ...(await authHeaders()) },
  });
  if (!res.ok) throw new Error(await res.text());
  const json = res.json();
  return await json;
}

export async function listIntegrationSummaries(workgroupId) {
  const query = workgroupId ? `?workgroupId=${encodeURIComponent(workgroupId)}` : '';
  const res = await fetch(`/api/server/integrationList${query}`, {
    headers: { 'Content-Type': 'application/json', ...(await authHeaders()) },
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function getIntegration(id) {
  const res = await fetch(`/api/server/v1/integrations/${id}`, {
    headers: { ...(await authHeaders()) },
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function saveIntegration(doc) {
  const res = await fetch(`/api/server/v1/integrations`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(await authHeaders()) },
    body: JSON.stringify(doc),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function deleteIntegration(id) {
  const res = await fetch(`/api/server/v1/integrations/${id}`, {
    method: 'DELETE',
    headers: { ...(await authHeaders()) },
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}
